/* Core Energy, shared behaviors for ce-* sections. Safe to include multiple times. */
(function () {
  if (window.__ceCore) return;
  window.__ceCore = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Rails: arrow buttons ---------- */
  function initRail(root) {
    var rail = root.querySelector('[data-ce-rail]');
    var prev = root.querySelector('[data-ce-prev]');
    var next = root.querySelector('[data-ce-next]');
    if (!rail || !prev || !next || rail.__ce) return;
    rail.__ce = true;
    function step() {
      var item = rail.firstElementChild;
      if (!item) return rail.clientWidth;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }
    function update() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max;
    }
    prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
    next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
    rail.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Background / inline videos: play only when visible ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting && v.offsetParent !== null && !v.__cePaused) {
        if (v.preload === 'none') v.preload = 'auto';
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else if (!e.isIntersecting && !v.paused) {
        v.pause();
      }
    });
  }, { threshold: 0.35 }) : null;

  function initAutoVideos(root) {
    root.querySelectorAll('video[data-ce-autoplay]').forEach(function (v) {
      if (v.__ce) return; v.__ce = true;
      v.muted = true;
      if (reduceMotion) return;
      if (io) io.observe(v);
    });
  }

  /* ---------- UGC tiles: tap to play / pause, mute toggle ---------- */
  function initUgc(root) {
    root.querySelectorAll('[data-ce-clip]').forEach(function (tile) {
      if (tile.__ce) return; tile.__ce = true;
      var v = tile.querySelector('video');
      if (!v) return;
      var toggle = tile.querySelector('[data-ce-clip-toggle]');
      var mute = tile.querySelector('[data-ce-clip-mute]');
      function sync() { tile.classList.toggle('is-playing', !v.paused); tile.classList.toggle('is-unmuted', !v.muted); }
      if (toggle) toggle.addEventListener('click', function () {
        if (v.paused) {
          root.querySelectorAll('[data-ce-clip] video').forEach(function (o) { if (o !== v && !o.paused) { o.pause(); o.__cePaused = true; } });
          v.__cePaused = false;
          if (v.preload === 'none') v.preload = 'auto';
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else { v.pause(); v.__cePaused = true; }
      });
      if (mute) mute.addEventListener('click', function () { v.muted = !v.muted; sync(); });
      ['play', 'pause', 'volumechange'].forEach(function (ev) { v.addEventListener(ev, sync); });
      sync();
    });
  }

  /* ---------- Review filter tabs ---------- */
  function initFilter(root) {
    var tabs = root.querySelectorAll('[data-ce-filter]');
    if (!tabs.length || root.__ceFilter) return;
    root.__ceFilter = true;
    var items = root.querySelectorAll('[data-ce-tag]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var val = tab.getAttribute('data-ce-filter');
        tabs.forEach(function (t) { t.setAttribute('aria-pressed', t === tab ? 'true' : 'false'); });
        items.forEach(function (it) { it.hidden = !(val === 'all' || it.getAttribute('data-ce-tag') === val); });
        var rail = root.querySelector('[data-ce-rail]');
        if (rail) { rail.scrollLeft = 0; rail.dispatchEvent(new Event('scroll')); }
      });
    });
  }

  /* ---------- Product form: option pills → variant, AJAX add ---------- */
  function money(cents) {
    var fmt = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: fmt }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  function initProductForm(root) {
    var form = root.querySelector('[data-ce-product-form]');
    if (!form || form.__ce) return;
    form.__ce = true;
    var json = root.querySelector('[data-ce-variants]');
    var variants = json ? JSON.parse(json.textContent) : [];
    var idInput = form.querySelector('input[name="id"]');
    var btn = form.querySelector('[type="submit"]');
    var btnLabel = btn ? btn.querySelector('[data-ce-btn-label]') : null;
    var priceEl = root.querySelector('[data-ce-price]');
    var compareEl = root.querySelector('[data-ce-compare]');
    var errorEl = root.querySelector('[data-ce-error]');
    var defaultLabel = btnLabel ? btnLabel.textContent : '';

    function current() {
      var opts = [];
      form.querySelectorAll('[data-ce-option]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        opts.push(checked ? checked.value : null);
      });
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function update() {
      var v = current();
      if (!btn) return;
      if (!v) { btn.disabled = true; if (btnLabel) btnLabel.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      btn.disabled = !v.available;
      if (btnLabel) btnLabel.textContent = v.available ? defaultLabel : 'Sold out';
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) { compareEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
      var sticky = document.querySelector('[data-ce-sticky-price]');
      if (sticky) sticky.textContent = money(v.price);
    }
    form.addEventListener('change', function (e) { if (e.target.closest('[data-ce-option]')) update(); });
    update();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!btn || btn.disabled) return;
      btn.disabled = true;
      btn.classList.add('is-loading');
      if (errorEl) errorEl.textContent = '';
      var body = { items: [{ id: Number(idInput.value), quantity: 1 }] };
      var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root_url + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          btn.classList.remove('is-loading');
          if (!res.ok) {
            btn.disabled = false;
            if (errorEl) errorEl.textContent = res.data.description || res.data.message || 'Could not add to cart.';
            return;
          }
          var evt = new CustomEvent('ce:cart:add', { detail: res.data, bubbles: true, cancelable: true });
          var notCancelled = document.dispatchEvent(evt);
          // No cart drawer has claimed the event yet → go to the cart page.
          if (notCancelled && !window.ceCartDrawer) {
            window.location.href = root_url + 'cart';
            return;
          }
          btn.disabled = false;
        })
        .catch(function () {
          btn.disabled = false; btn.classList.remove('is-loading');
          if (errorEl) errorEl.textContent = 'Something went wrong. Please try again.';
        });
    });
  }

  /* ---------- Sticky add-to-cart bar (mobile) ---------- */
  function initSticky(root) {
    var bar = root.querySelector('[data-ce-sticky]');
    var target = root.querySelector('[data-ce-product-form] [type="submit"]');
    if (!bar || !target || bar.__ce || !('IntersectionObserver' in window)) return;
    bar.__ce = true;
    document.body.appendChild(bar);
    var sectionEl = root;
    var formVisible = true, sectionVisible = false;
    function set() { bar.classList.toggle('is-visible', !formVisible && sectionVisible); }
    new IntersectionObserver(function (es) { formVisible = es[0].isIntersecting || es[0].boundingClientRect.top > 0; set(); }).observe(target);
    new IntersectionObserver(function (es) { sectionVisible = es[0].isIntersecting; set(); }, { rootMargin: '0px 0px 200px 0px' }).observe(sectionEl);
    var sbtn = bar.querySelector('button');
    if (sbtn) sbtn.addEventListener('click', function () {
      if (target.disabled) { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      target.click();
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ce-section]').forEach(function (el) {
      initRail(el);
      initAutoVideos(el);
      initUgc(el);
      initFilter(el);
      initProductForm(el);
      initSticky(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    document.querySelectorAll('[data-ce-sticky][data-ce-owner="' + e.detail.sectionId + '"]').forEach(function (b) { b.remove(); });
  });
})();
